import { LauncherModulesState } from '@layout/launcher/store/states/launcher-modules.state';

export const launcherState = [LauncherModulesState];
